<template>
    <div ref="container" class="container d-flex flex-column h-100">
            <div>
                <header class="text-center pt-4 p-3" style="z-index: 100;">
                    
                </header>

                <div class="" style="text-align:center; margin:15% 0; width: 100%">
                    <div class="">
                        <!-- <img src="img/askmygp-logo.svg" alt="askmyGP logo" style="width: 200px;margin-bottom:20px;"> -->
                    </div>
                    
                    <h1>{{ this.$root.appStatusMessage }}</h1>
                    <template v-if="!this.$root.failedToLoad">
                        <p style="font-size: 20px;">{{ $t('translations.please_be_patient')}}</p>
                        <p style="font-size: 16px;">{{ $t('translations.loading_browser_support_message')}}</p>
                    </template>
                    <!-- <template v-else> -->
                        <p>
                            <a style='color: initial; text-decoration: underline' target='app_service_status' href='https://askmygp.uk/private/status/'>View Service Status Page</a>
                        </p>
                    <!-- </template> -->
                    
                </div>


            </div>
            
    </div><!--ref:container-->


</template>

<script>
export default {
    props: [
    ],
    data: function(){
        return {
            scrollTo: null,
        }
    },
    mounted() {
        if(this.$root.isLoggedIn()) {
            this.$router.replace({name: "Profile"});
        }
    },
    computed: {

    },
    methods: {

    }
}
</script>
